import { render, staticRenderFns } from "./InvitationsActionsDialog.vue?vue&type=template&id=4786cfc6&"
import script from "./InvitationsActionsDialog.vue?vue&type=script&lang=js&"
export * from "./InvitationsActionsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports